import router from '@/router';
import { i18n } from '@/plugins/lang';

const pointErrorMsg = (val) => {
  if (val === 3008) {
    return {
      type: 'confirm',
      message: i18n.t('error.point.3008'),
      callback: () => {
        router.replace({ name: 'UserInfoRegister' });
      },
    };
  } else if (val === 3017) {
    // 회원 DB이름과 계좌주명 불일치
    return {
      type: 'confirm',
      message: i18n.t('error.point.3017'),
      callback: () => {
        if (window.parent) {
          window.parent.location.href = '/userInfo/userInfo/view';
        } else {
          router.replace({ name: 'UserInfoView' });
        }
      },
    };
  }

  const messageList = i18n.t('error.point');
  if (messageList[val]) {
    return { type: 'alert', message: messageList[val] };
  }
  return { type: 'alert', message: messageList.default };
};

const pointHistoryErrorMsg = (val) => {
  const messageList = i18n.t('error.pointHistory');
  if (messageList) {
    return messageList[val];
  }
  return messageList.default;
};

const exchangeHistoryErrorMsg = (val) => {
  const messageList = i18n.t('error.exchangeHistory');
  if (messageList) {
    return messageList[val];
  }
  return messageList.default;
};

// Error messages only for the krpc page
const exchangeErrorPage = (val) => {
  switch (val) {
    case 3001:
      return `<h3>본인확인을 해주세요</h3>
        <p>
          포인트 전환 신청은 본인 확인이 완료된 아이디만 이용이 가능합니다.<br>
          내정보&gt;내정보관리&gt;개인정보변경에서 본인확인 후 이용해주세요.
        </p>`;
    case 3002:
      return `<h3>서비스를 이용할 수 없습니다.</h3>
        <p>만 14세 미만 고객님께서는 포인트 전환 신청을 할 수 없습니다.</p>`;
    case 3008:
      return `<h3>포인트 전환 신청을 할 수 없습니다. </h3>
        <p>포인트 전환 신청은 사용자 정보와 수입 지급 계좌 정보를 등록 한 뒤 이용하실 수 있습니다.</p>`;
    case 3009:
      return `<h3>포인트 전환 신청을 할 수 없습니다. </h3>
        <p>고객님은 현재 사업자 회원으로 등록되어 있습니다.<br> 사업자는 매월 1일 전월에 획득한 포인트에 대해 자동으로 전환신청이 되고​ 전자 세금계산서를 통해 수입을 지급받을 수 있습니다.​</p>`;
    case 1:
      return `<h3>점검 중 입니다. </h3>
        <p>서비스 점검중으로 포인트 전환 신청을 할 수 없습니다.<br>점검 종료 후 다시 이용 부탁드립니다.</p>`;
    default:
      return `<h3>다시 시도해 주세요.</h3>
        <p>서비스 연결이 원활하지 않습니다.<br>잠시 후 다시 시도해 주세요.</p>`;
  }
};

// Error messages only for the jppc page
const authNJErrorMsg = (message) => {
  return {
    type: 'alert',
    message: message || 'unknown Error',
  };
};
export { pointErrorMsg, exchangeErrorPage, pointHistoryErrorMsg, exchangeHistoryErrorMsg, authNJErrorMsg };
